import React, { Component } from "react";
import ContentWrapper from "../../../components/common/ContentWrapper.js";
import Card from "../../../components/common/Card.js";
import CardHeader from "../../../components/common/CardHeader.js";
import CardBody from "../../../components/common/CardBody.js";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { CountryService } from "../../../service/settings/manage/country.service.js";
import { ProvinceService } from "../../../service/settings/manage/province.service.js";
import { CityService } from "../../../service/settings/manage/city.service.js";
import { GenderService } from "../../../service/settings/manage/gender.service.js";
import { StatusTypesService } from "../../../service/settings/manage/status_type.service.js";
import { StatusService } from "../../../service/settings/manage/status.service.js";
import Spinner from "react-bootstrap/Spinner";
import "../../../components/admin/css/common.css";
import { history } from "../../../helper/history.js";
import debounce from "lodash.debounce";
import { UserManagementService } from "../../../service/user_management/user_management.service.js";
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
} from "@mui/material";
import MaterialCustomTablePagination from "../../../components/common/MaterialCustomTablePagination.js";
import sweetAlert, {
  sweetStatusAlert,
} from "../../../components/common/SweetAlert.js";
// import { TeacherService } from "../../../service/manage/registration/teacher.service.js";
import { TeacherService } from "../../../service/manage/registration/reg_b_teacher.service.js";
import SimpleReactValidator from "simple-react-validator";
import PageSpinner from "../../../components/common/spinner/PageSpinner.js";
import { roleService } from "../../../service/user_management/role.service.js";
import { StaffService } from "../../../service/user_management/staff.service.js";
import RegBAddTeacherModel from "../dashboard/registration_b/components/RegBAddTeacherModel.js";
import config from "../../../helper/config.js";
import { customerConstants } from "../../../helper/constants.js";
import RegBTeacherDocUpdate from "../dashboard/registration_b/components/RegBTeacherDocUpdateModel.js";
import SummarizeIcon from "@mui/icons-material/Summarize";
import { modeService } from "../../../service/settings/manage/mode_of_employment.service.js";
import { employmentTypeService } from "../../../service/settings/manage/employment_type.service.js";
import { educationService } from "../../../service/settings/manage/educational_qualification.service.js";
import {
  Checkbox,
  TableContainer,
  CircularProgress,
  Paper,
} from "@mui/material";
import DatePicker from "react-datepicker";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle;
const customer = getCustomerFeatureFlag();
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    break;
  case customerConstants.EXO_CUSTOMER2:
    closeBtnStyle = {
      color: "var(--maincolor-cmc)",
      backgroundColor: "#E5F5FF",
      borderColor: "transparent",
    };
    addBtnStyle = {
      color: "#fff",
      backgroundColor: "var(--maincolor-cmc)",
      borderColor: "transparent",
    };
    break;
  default:
    break;
}

export default class RegBManageTeacher extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      teachers: [],
      first_name: "",
      last_name: "",
      nic: "",
      dob: "",
      email: "",
      phone_number: "",
      gender_id: "",
      status_id: "",
      created_on: "",
      created_by: "",
      genders: [],
      titles: [],
      countries: [],
      provinces: [],
      cities: [],
      adm_statuses: [],
      statusTypes: [],
      AdmStatustype: "Availability",
      showInsertModal: false,
      isLoading: false,
      isTableDataLoading: true,
      limit: 10, // Set the desired limit
      offset: 0, // Set the desired offset
      search_term: "",
      totalTeachers: 10,
      currentPage: 0,
      isModified: false,
      isAddressesLoading: false,
      editVisibility: false,
      addVisibility: false,
      deleteVisibility: false,
      sortColumn: "user_code", // Default sort column
      sortDirection: "desc",
      errorProvince: [],
      errorCity: [],
      addressValidity: [],
      hidden: false,
      node_mid: null,
      user_list_table_id: null,
      session_adm_id: null,
      country_id: "",
      province_id: "",
      city_id: "",
      address_1: "",
      address_2: "",
      postalcode: "",
      user_id: "",
      is_lg_user: "",
      user_name: "",
      breadcrumb2: null,
      nodeTitle: null,
      main_table_id: null,
      user_code: "",
      showPrivModel: false,
      roles: [],
      role_code: null,
      assignedRoles: [],
      privilegedTeacher: null,
      isAddTeacherModalOpen: false,
      isPrivilegeModalLoading: false,
      isModalLoading: false,
      selectedTeacherForUpdate: null,
      regBDocUpdateModel: false,

      empTypes: [],
      education: [],
      edu_id: "",
      modes: [],
      mode_id: "",
      higher_professional_qualifications: "",
      industry_experience: "",
      teaching_experience: "",

      lg_user_id: sessionStorage.getItem("manage_user_id"),
      lg_user_table_id: sessionStorage.getItem("table_log_id"),
      teacherLoading: false,
      enrollments: [],
      checked_enrollments: [],
    };
    // Debounced version of handleSearch function
    this.debouncedHandleSearch = debounce(this.fetchAllTeachers, 2000);

    this.createValidationsInstance();
    this.formInitialState = {
      first_name: "",
      last_name: "",
      nic: "",
      dob: "",
      email: "",
      phone_number: "",
      gender_id: "",
      status_id: "",
      created_on: "",
      created_by: "",
      postalcode: "",
    };
  }

  createValidationsInstance() {
    this.validator = new SimpleReactValidator({
      validators: {
        address: {
          message: "The :attribute must be a valid address",
          rule: (val, params, validator) => {
            return (
              validator.helpers.testRegex(val, /^[a-zA-Z-/:0-9,\s]+$/i) &&
              params.indexOf(val) === -1
            );
          },
          messageReplace: (message, params) =>
            message.replace(":values", this.helpers.toSentence(params)), // optional
        },
        dateBefore: {
          message: "The :attribute must be before current date",
          rule: (val, params, validator) => {
            const currentDate = new Date().toISOString().split("T");
            return val < currentDate[0];
          },
          messageReplace: (message, params) =>
            message.replace(":values", this.helpers.toSentence(params)), // optional
          required: true,
        },
        phone_number: {
          message: "The :attribute must be a valid phone number",
          rule: (val, params, validator) => {
            const isTenDigitsStartingWithZero =
              val.length === 10 && val.startsWith("0");
            const isNineDigits = val.length === 9 && !val.startsWith("0");
            return isTenDigitsStartingWithZero || isNineDigits;
          },
          messageReplace: (message, params) =>
            message.replace(":values", this.helpers.toSentence(params)), // optional
          required: true,
        },
      },
    });
    this.updateValidator = new SimpleReactValidator();
  }

  componentDidMount() {
    this.loadInitialData();
    this.genarateStudentIdPrefix();
  }

  genarateStudentIdPrefix() {
    const id_prefix = this.props.state?.mcode;
    const id_prefix_year = String(new Date().getFullYear() % 100);

    const user_base_prefix = id_prefix + id_prefix_year + "T";

    this.setState({ user_code: user_base_prefix });
  }

  handleSearch = (event) => {
    const search_term = event.target.value.trim();
   
      this.setState(
        {
          search_term,
          isTableDataLoading: true,
          offset: 0,
          currentPage: 0,
          searchError: false,
        },
        () => {
          // Call the debounced version of fetchStudentData
          this.debouncedHandleSearch();
        }
      );
  };

  toggleRegBDocUpdateModel = (teacher) => {
    this.setState((prevState) => {
      return {
        selectedTeacherForUpdate: teacher,
        regBDocUpdateModel: !prevState.regBDocUpdateModel,
      };
    });
  };

  loadInitialData() {
    let privilege_edit = !!this.props.state?.privilege_edit;
    let privilege_add = !!this.props.state?.privilege_add;
    let privilege_delete = !!this.props.state?.privilege_delete;
    this.setState(
      {
        addVisibility: privilege_add,
        editVisibility: privilege_edit,
        deleteVisibility: privilege_delete,
        user_list_table_id: sessionStorage.getItem("table_log_id"),
        session_adm_id: sessionStorage.getItem("manage_user_id"),
        breadcrumb2: this.props.state?.breadcrumb2,
        nodeTitle: this.props.state?.nodeTitle,
        main_table_id: this.props.state?.main_table_id,
      },
      () => {
        this.fetchAllTeachers();
        this.getAllGenders();
        this.getAllStatusTypes();
        this.getAllRoles();

        this.getAllEmpTypes();
        this.getAllEducations();
        this.getAllModes();
      }
    );
  }

  getAllRoles() {
    this.setState({ isPrivilegeModalLoading: true });
    roleService.getAll().then((res) => {
      this.setState({ roles: res.data });
    });
    this.setState({ isPrivilegeModalLoading: false });
  }

  getAllGenders() {
    GenderService.getAllGenders().then((res) => {
      this.setState({ genders: res.data });
    });
  }

  getAllStatusTypes() {
    StatusTypesService.getAll().then((res) => {
      this.setState({ statusTypes: res.data }, () => {
        this.getAllStatuses();
      });
    });
  }

  getAllModes() {
    modeService.getAllModes().then((res) => {
      this.setState({ modes: res.data });
    });
  }

  getAllEmpTypes() {
    employmentTypeService.getAllEmpTypes().then((res) => {
      this.setState({ empTypes: res.data });
    });
  }

  getAllEducations() {
    educationService.getAllEducation().then((res) => {
      this.setState({ education: res.data });
    });
  }

  getAllStatuses() {
    const adm_type_id = this.getRespectiveStatusTypeID(
      this.state.AdmStatustype
    );
    StatusService.getByTypeId(adm_type_id).then((res) => {
      this.setState({ adm_statuses: res.data });
    });
  }

  fetchAllTeachers = async () => {
    const {
      limit,
      offset,
      sortColumn,
      sortDirection,
      search_term,
      user_list_table_id,
      session_adm_id,
    } = this.state;
    const {
      mid,
      owner_restriction,
      lg_user_id,
      lg_user_table_id,
      user_list_restriction,
    } = this.props.state;
    let create_user_id =
      !!owner_restriction && lg_user_id ? lg_user_id : "null";
    let create_user_table_id =
      !!owner_restriction && lg_user_table_id ? lg_user_table_id : "null";
    let user_table_id =
      !!user_list_restriction && user_list_table_id
        ? user_list_table_id
        : "null";
    let user_id =
      !!user_list_restriction && session_adm_id ? session_adm_id : "null";

    await TeacherService.getAll(
      user_id,
      user_table_id,
      create_user_id,
      create_user_table_id,
      mid,
      limit,
      offset,
      sortColumn,
      sortDirection,
      search_term
    )
      .then((response) => {
        if (response.success) {
          this.setState({
            teachers: response.data.teachers,
            totalTeachers: response.data.total_count, // Update totalTeachers with the correct count
          });
        } else {
          sweetStatusAlert(
            "Failed!",
            "Error fetching teachers Please refresh the screen!",
            "error"
          );
        }
      })
      .catch((error) => {
        // Handle any error that occurred during the API call
        sweetStatusAlert(
          "Failed!",
          "Error fetching teachers Please refresh the screen!",
          "error"
        );
      })
      .finally(() => {
        this.setState({ isTableDataLoading: false });
      });
  };

  handlePageChange = (event, newPage) => {
    const { limit } = this.state;
    const newOffset = newPage * limit;
    this.setState(
      {
        offset: newOffset,
        isTableDataLoading: true,
        currentPage: newPage,
      },
      () => {
        this.fetchAllTeachers();
      }
    );
  };

  handlePageOffsetChange = (newOffset, newPage) => {
    this.setState(
      {
        offset: newOffset,
        isTableDataLoading: true,
        currentPage: newPage,
      },
      () => {
        this.fetchAllTeachers();
      }
    );
  };

  handleRowsPerPageChange = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    const newPage = Math.floor(this.state.offset / newLimit);
    this.setState(
      {
        limit: newLimit,
        offset: newLimit * newPage,
        isTableDataLoading: true,
        currentPage: newPage,
      },
      () => {
        this.fetchAllTeachers();
      }
    );
  };

  handleSortChange = (sortColumn) => {
    // If the same column is clicked, toggle the sort direction
    const { sortColumn: currentSortColumn, sortDirection } = this.state;
    const newSortDirection =
      currentSortColumn === sortColumn && sortDirection === "asc"
        ? "desc"
        : "asc";

    this.setState(
      {
        sortColumn,
        sortDirection: newSortDirection,
        offset: 0, // Reset offset when changing sorting
        currentPage: 0,
        isTableDataLoading: true,
      },
      () => {
        this.fetchAllTeachers();
      }
    );
  };

  handleSweetAlert = (toggleFunction, modalVisibility) => {
    if (this.state.isModified) {
      sweetAlert().then((response) => {
        this.validator.purgeFields();
        this.validator.hideMessages();
        this.setState(this.formInitialState);
        this.setState(() => ({
          [modalVisibility]: response,
          isModified: false,
        }));
      });
    } else {
      this.validator.purgeFields();
      this.validator.hideMessages();
      this.setState(this.formInitialState);
      toggleFunction();
    }
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState(() => ({ [name]: value, isModified: true }));
  };

  togglePrivAddition = async (teacher) => {
    this.setState({ isModalLoading: true });
    if (!!teacher) {
      await StaffService.searchRegBStaffByTableAndUserIds(
        teacher?.user_id,
        this.state.main_table_id
      ).then((res) => {
        this.setState(() => ({
          assignedRoles: res.data,
        }));
      });
      this.setState(() => ({
        privilegedTeacher: teacher,
      }));
    }
    this.setState((prev) => ({
      showPrivModel: !prev.showPrivModel,
    }));
    this.setState({ isModalLoading: false });
  };

  close = () => {
    this.setState((prev) => ({
      showPrivModel: !prev.showPrivModel,
    }));
  };

  handleDatePickerChange = (value) => {
    const dateObject = value ? new Date(value) : undefined;
    const year = dateObject.getFullYear();
    const month = ("0" + (dateObject.getMonth() + 1)).slice(-2); // Adding 1 because getMonth() returns zero-based index
    const day = ("0" + dateObject.getDate()).slice(-2);

    const formattedDateString = `${year}-${month}-${day}`;
    this.setState(() => ({ dob: formattedDateString, isModified: true }));
  };

  handleCheckboxChange = (mid) => {
    this.setState((prevState) => {
      const { checked_enrollments } = prevState;
      if (checked_enrollments.includes(mid)) {
        return {
          checked_enrollments: checked_enrollments.filter((id) => id !== mid),
        };
      } else {
        return {
          checked_enrollments: [...checked_enrollments, mid],
        };
      }
    });
  };

  toggleUpdateTeacherModal = (teacher) => {
    this.setState(
      (prevState) => ({
        showModal: !prevState.showModal,
        first_name: "",
        last_name: "",
        dob: "",
        email: "",
        phone_number: "",
        gender_id: "",
        status_id: "",
        created_on: "",
        created_by: "",
        address_1: "",
        address_2: "",
        city_id: "",
        province_id: "",
        postalcode: "",
        country_id: "",
        user_code: "",
        nic: "",
        type_id: "",
        mode_id: "",
        edu_id: "",
        higher_professional_qualifications: "",
        industry_experience: "",
        teaching_experience: "",
        checked_enrollments: [],
        enrollments: [],
      }),
      async () => {
        // State has changed, perform your logic here based on the state change
        if (this.state.showModal) {
          this.setState({
            first_name: teacher.first_name,
            last_name: teacher.last_name,
            nic: teacher.nic.toString(),
            email: teacher.email,
            phone_number: teacher.mobile
              ? teacher.mobile.toString()
              : teacher.mobile,
            dob: teacher.dob ? teacher.dob : "",
            gender_id: teacher.gender_id ? teacher.gender_id : "",
            created_on: teacher.created_on ? teacher.created_on : "",
            created_by: teacher.created_by ? teacher.created_by : "",
            status_id: teacher.user_status_id ? teacher.user_status_id : "",
            user_id: teacher.user_id,
            node_mid: teacher.node_mid,
            address_1: teacher.address_1,
            address_2: teacher.address_2,
            city_id: teacher.city_id,
            province_id: teacher.province_id,
            postalcode: teacher.postalcode,
            country_id: teacher.country_id,
            is_lg_user: teacher.is_lg_user,
            user_code: teacher.user_code,
            type_id: teacher.employee_type,
            mode_id: teacher.mode_of_employment,
            edu_id: teacher.higher_educational_qualifications,
            higher_professional_qualifications:
              teacher.higher_professional_qualifications,
            industry_experience: teacher.industry_experience,
            teaching_experience: teacher.teaching_experience,
            checked_enrollments: teacher.enrolled_nodes,
          });

          this.fetchTeacherEnrollments();
        }
      }
    );
  };

  //Handle Edit Submit
  handleEditSubmit = async (event) => {
    event.preventDefault();
    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
    } else {
      try {
        this.setState({ isLoading: true });
        const {
          first_name,
          last_name,
          email,
          phone_number,
          dob,
          gender_id,
          status_id,
          address_1,
          nic,
          type_id,
          mode_id,
          edu_id,
          higher_professional_qualifications,
          industry_experience,
          teaching_experience,
          node_mid,
          user_id,
          is_lg_user,
          checked_enrollments,
        } = this.state;

        const teacherItem = {
          first_name: first_name,
          last_name: last_name,
          email: email,
          mobile: parseInt(phone_number),
          dob: !!dob ? dob : null,
          gender_id: parseInt(gender_id),
          user_status_id: parseInt(status_id),
          address_1: address_1,
          node_mid: node_mid, //
          nic: nic,
          employee_type: parseInt(type_id),
          mode_of_employment: parseInt(mode_id),
          higher_educational_qualifications: parseInt(edu_id),
          industry_experience: industry_experience,
          teaching_experience: teaching_experience,
          higher_professional_qualifications:
            higher_professional_qualifications,
          checked_enrollments: checked_enrollments,
        };

        const teacherId = user_id;
        this.setState({ showModal: false }, async () => {
          const teacherResponse = await TeacherService.update(
            teacherItem,
            teacherId
          );

          if (teacherResponse.success) {
            this.fetchAllTeachers();
            let usertype = sessionStorage.getItem("userType");
            if ("teacher" === usertype && !!is_lg_user) {
              sessionStorage.setItem("username", first_name + " " + last_name);
              this.setState({
                user_name: first_name + " " + last_name,
              });
            }
            this.setState({ isLoading: false, showModal: false });
            sweetStatusAlert(
              "Success!",
              "Teacher information updated successfully..!",
              "success"
            );

            this.validator.purgeFields();
            this.validator.hideMessages();
            this.setState(this.formInitialState);
          } else {
            this.setState({ isLoading: false });
            sweetStatusAlert("Failed!", teacherResponse.message, "error");
          }
        });
      } catch (e) {
        this.setState({ isLoading: false });
        sweetStatusAlert("Failed!", e, "error");
      }
    }
  };

  getRespectiveStatusTypeID(name) {
    const type = this.state.statusTypes?.find((item) => item.name === name);
    return type ? type.type_id : "";
  }

  getRespectiveRoleCode(role_code) {
    const roleData = this.state.roles.find(
      (role) => role.role_code === role_code
    );
    return roleData;
  }

  handleDeleteRoleCode = async (teacherRole) => {
    try {
      this.setState({ isPrivilegeModalLoading: true });
      await UserManagementService.deleteRoleCode(
        teacherRole.role_code,
        teacherRole.user_id
      );
      await StaffService.searchRegBStaffByTableAndUserIds(
        this.state.privilegedTeacher?.user_id,
        this.state.main_table_id
      ).then((res) => {
        this.setState(() => ({
          assignedRoles: res.data,
        }));
      });
      this.setState({ isPrivilegeModalLoading: false });
    } catch (error) {}
  };

  getRespectiveRoleCode(role_code) {
    const roleData = this.state.roles.find(
      (role) => role.role_code === role_code
    );
    return roleData;
  }

  handleCreateRole = async () => {
    if (this.state.assignedRoles.length > 0) {
      const teacherUserRoleData = {
        user_id: this.state.assignedRoles[0].user_id,
        module:
          "Manage " +
          this.getRespectiveRoleCode(this.state.role_code).role_code,
        role_code: this.getRespectiveRoleCode(this.state.role_code).role_code,
      };
      try {
        this.setState({ isPrivilegeModalLoading: true });
        const result = await UserManagementService.createStaffRole(
          JSON.stringify(teacherUserRoleData)
        );
        if (!result.success) {
          sweetStatusAlert("Failed", result.message.error, "error");
        } else {
          await StaffService.searchRegBStaffByTableAndUserIds(
            this.state.privilegedTeacher?.user_id,
            this.state.main_table_id
          ).then((res) => {
            this.setState(() => ({
              assignedRoles: res.data,
            }));
          });
        }
        this.setState({ isPrivilegeModalLoading: false });
      } catch (error) {
        sweetStatusAlert("Failed", error, "error");
      }
    } else {
      sweetStatusAlert("Failed", "Cant able to Add Role", "error");
    }
  };

  handleDeleteRoleCode = async (teacherRole) => {
    try {
      this.setState({ isPrivilegeModalLoading: true });
      await UserManagementService.deleteRoleCode(
        teacherRole.role_code,
        teacherRole.user_id
      );
      await StaffService.searchRegBStaffByTableAndUserIds(
        this.state.privilegedTeacher?.user_id,
        this.state.main_table_id
      ).then((res) => {
        this.setState(() => ({
          assignedRoles: res.data,
        }));
      });
      this.setState({ isPrivilegeModalLoading: false });
    } catch (error) {}
  };

  async fetchTeacherEnrollments() {
    this.setState({ teacherLoading: true });
    const { mid } = this.props.state;
    const { lg_user_id, lg_user_table_id } = this.state;

    await TeacherService.getEnrollments(mid, lg_user_id, lg_user_table_id)
      .then((res) => {
        if (res.success) {
          this.setState({ enrollments: res.data, teacherLoading: false });
        } else {
          this.setState({ teacherLoading: false });
        }
      })
      .catch((err) => {
        this.setState({ teacherLoading: false });
      });
  }

  toggleAddTeacherModal = () => {
    this.setState(
      (prevState) => ({
        showInsertModal: !prevState.showInsertModal,
        first_name: "",
        last_name: "",
        dob: "",
        email: "",
        phone_number: "",
        gender_id: "",
        status_id: "",
        created_on: "",
        created_by: "",
        address_1: "",
        address_2: "",
        city_id: "",
        province_id: "",
        postalcode: "",
        country_id: "",
        type_id: "",
        mode_id: "",
        edu_id: "",
        higher_professional_qualifications: "",
        industry_experience: "",
        teaching_experience: "",
      }),
      () => {}
    );
  };

  toggleAddSeparateTeacherModal = () => {
    this.setState(
      (prevState) => ({
        isAddTeacherModalOpen: !prevState.isAddTeacherModalOpen,
      }),
      () => {
        if (this.state.isAddTeacherModalOpen) {
          this.fetchTeacherEnrollments();
        }
      }
    );
  };

  render() {
    const {
      isLoading,
      isModalLoading,
      countries,
      limit,
      teachers,
      totalTeachers,
      isTableDataLoading,
      currentPage,
      first_name,
      last_name,
      email,
      phone_number,
      dob,
      gender_id,
      created_on,
      created_by,
      status_id,
      genders,
      adm_statuses,
      editVisibility,
      deleteVisibility,
      country_id,
      province_id,
      city_id,
      address_1,
      address_2,
      postalcode,
      provinces,
      cities,
      user_name,
      breadcrumb2,
      nodeTitle,
      addVisibility,
      user_code,
      roles,
      role_code,
      assignedRoles,
      nic,
      type_id,
      empTypes,
      education,
      edu_id,
      modes,
      mode_id,
      higher_professional_qualifications,
      teaching_experience,
      industry_experience,
      enrollments,
      teacherLoading,
      checked_enrollments,
    } = this.state;
    const path = history.location.pathname;
    this.validator.purgeFields();
    let fromProfile = false;
    if (this.props.state.path === "profile") {
      fromProfile = true;
    }
    return (
      <>
        <div style={{ overflow: "auto", height: "90vh" }}>
          <ContentWrapper disabled={path === "/manage-search"}>
            <RegBTeacherDocUpdate
              regBDocUpdateModel={this.state.regBDocUpdateModel}
              toggleRegBDocUpdateModel={this.toggleRegBDocUpdateModel}
              closeBtnStyle={closeBtnStyle}
              selectedTeacher={this.state.selectedTeacherForUpdate}
              state={this.props.state}
              fetchAllStudents={this.fetchAllStudents}
            />
            <Card>
              <CardHeader>
                <div>
                  {this.props.state?.path !== "node" && !fromProfile && (
                    <p
                      className="py-4"
                      style={{
                        color: "gray",
                        fontSize: "10.5625px",
                        color: "#00000099",
                      }}
                    >
                      {breadcrumb2 || nodeTitle
                        ? `${breadcrumb2 && breadcrumb2}${
                            nodeTitle && nodeTitle
                          }`
                        : undefined}
                    </p>
                  )}
                  {!fromProfile && (
                    <Form.Group
                      controlId="exampleForm.ControlInput1"
                      className="mb-2"
                    >
                      <Form.Control
                        type="text"
                        placeholder="Search"
                        onChange={this.handleSearch}
                        style={{ width: "300px" }}
                      />
                    </Form.Group>
                  )}
                </div>
                <div>
                  {addVisibility && !fromProfile && (
                    <Button
                      className="insert-btn"
                      variant="primary"
                      onClick={this.toggleAddSeparateTeacherModal}
                    >
                      Add Teacher
                    </Button>
                  )}
                </div>
              </CardHeader>
              <CardBody>
                {isLoading && (
                  <PageSpinner id="show" text="Loading, Please wait!" />
                )}
                {isModalLoading && (
                  <PageSpinner id="show" text="Loading, Please wait!" />
                )}
                {isTableDataLoading ? (
                  <div className="loading-container">
                    <Spinner animation="border" role="status">
                      <span className="sr-only">Loading...</span>
                    </Spinner>
                  </div>
                ) : (
                  <div>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            className="thead"
                            style={{ cursor: "pointer" }}
                            onClick={() => this.handleSortChange("user_code")}
                          >
                            User Code{" "}
                            {this.state.sortColumn === "user_code" && (
                              <span>
                                {this.state.sortDirection === "asc"
                                  ? "⬇️"
                                  : "⬆️"}
                              </span>
                            )}
                          </TableCell>
                          <TableCell
                            className="thead"
                            style={{ cursor: "pointer" }}
                            onClick={() => this.handleSortChange("first_name")}
                          >
                            First Name{" "}
                            {this.state.sortColumn === "first_name" && (
                              <span>
                                {this.state.sortDirection === "asc"
                                  ? "⬇️"
                                  : "⬆️"}
                              </span>
                            )}
                          </TableCell>
                          <TableCell
                            className="thead"
                            style={{ cursor: "pointer" }}
                            onClick={() => this.handleSortChange("last_name")}
                          >
                            Last Name{" "}
                            {this.state.sortColumn === "last_name" && (
                              <span>
                                {this.state.sortDirection === "asc"
                                  ? "⬇️"
                                  : "⬆️"}
                              </span>
                            )}
                          </TableCell>
                          <TableCell
                            className="thead"
                            style={{ cursor: "pointer" }}
                            onClick={() => this.handleSortChange("email")}
                          >
                            Email{" "}
                            {this.state.sortColumn === "email" && (
                              <span>
                                {this.state.sortDirection === "asc"
                                  ? "⬇️"
                                  : "⬆️"}
                              </span>
                            )}
                          </TableCell>
                          <TableCell
                            className="thead"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              this.handleSortChange("phone_number")
                            }
                          >
                            Phone Number{" "}
                            {this.state.sortColumn === "phone_number" && (
                              <span>
                                {this.state.sortDirection === "asc"
                                  ? "⬇️"
                                  : "⬆️"}
                              </span>
                            )}
                          </TableCell>
                          <TableCell className="thead">Status</TableCell>
                          {(editVisibility || deleteVisibility) && (
                            <TableCell className="thead">Actions</TableCell>
                          )}
                          {(editVisibility || deleteVisibility) && (
                            <TableCell className="thead">Role</TableCell>
                          )}
                          {(editVisibility || deleteVisibility) && (
                            <TableCell className="thead">Documents</TableCell>
                          )}
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {teachers?.map((teacherItem) => (
                          <TableRow key={teacherItem.user_id}>
                            {/* <TableCell className="tData">
                              {adminItem.adm_id}
                            </TableCell> */}
                            <TableCell className="tData">
                              {teacherItem.user_code}
                            </TableCell>
                            <TableCell className="tData">
                              {teacherItem.first_name}
                            </TableCell>
                            <TableCell className="tData">
                              {teacherItem.last_name}
                            </TableCell>
                            <TableCell className="tData">
                              {teacherItem.email}
                            </TableCell>
                            <TableCell className="tData">
                              {teacherItem.mobile}
                            </TableCell>
                            {teacherItem.status ? (
                              <TableCell className="tData">
                                <span className="label label-lg label-light-success label-inline">
                                  {teacherItem.status}
                                </span>
                              </TableCell>
                            ) : (
                              <TableCell className="tData"></TableCell>
                            )}
                            {(editVisibility || deleteVisibility) && (
                              <TableCell>
                                <div className="btn-group">
                                  {editVisibility && (
                                    <Button
                                      onClick={() =>
                                        this.toggleUpdateTeacherModal(
                                          teacherItem
                                        )
                                      }
                                      className="btn btn-icon btn-primary btn-sm m-1 edit-assement-btn flaticon-edit-icon"
                                      title="Edit Details"
                                    />
                                  )}
                                </div>
                              </TableCell>
                            )}
                            {(editVisibility || deleteVisibility) && (
                              <TableCell>
                                <div className="btn-group">
                                  {editVisibility && (
                                    <Button
                                      onClick={() =>
                                        this.togglePrivAddition(teacherItem)
                                      }
                                      className="btn btn-icon btn-primary btn-sm m-1 edit-assement-btn flaticon-settings-1"
                                      title="Assign Role"
                                    />
                                  )}
                                </div>
                              </TableCell>
                            )}
                            {(editVisibility || deleteVisibility) && (
                              <TableCell>
                                <div className="btn btn-icon btn-primary btn-sm m-1 edit-assement-btn">
                                  <button
                                    style={{
                                      border: "none",
                                      backgroundColor: "transparent",
                                    }}
                                    onClick={() =>
                                      this.toggleRegBDocUpdateModel(teacherItem)
                                    }
                                  >
                                    <SummarizeIcon
                                      sx={{
                                        fontSize: 20,
                                        backgroundColor: "transparent",
                                        color: "#a2a5b5",
                                      }}
                                      style={{ cursor: "pointer" }}
                                    />
                                  </button>
                                </div>
                              </TableCell>
                            )}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                    {!fromProfile && (
                      <MaterialCustomTablePagination
                        totalCount={parseInt(totalTeachers)}
                        currentPage={currentPage}
                        limit={limit}
                        handlePageChange={this.handlePageChange}
                        handleRowsPerPageChange={this.handleRowsPerPageChange}
                        handlePageOffsetChange={this.handlePageOffsetChange}
                        rowsPerPageOptions={[5, 10, 20]}
                        offset={this.state.offset}
                      />
                    )}
                  </div>
                )}
              </CardBody>
            </Card>
          </ContentWrapper>

          <RegBAddTeacherModel
            state={this.props.state}
            isAddTeacherModalOpen={this.state.isAddTeacherModalOpen}
            toggleAddTeacherModal={this.toggleAddSeparateTeacherModal}
            fetchAllTeachers={this.fetchAllTeachers}
            enrollments={this.state.enrollments}
            teacherEnrollmentsLoading={this.state.teacherLoading}
          />

          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.showModal}
            onHide={() =>
              this.handleSweetAlert(
                this.toggleUpdateTeacherModal(this.state.privilegedTeacher),
                "showModal"
              )
            }
          >
            <Modal.Header closeButton>
              <Modal.Title>Update Teacher Information</Modal.Title>
            </Modal.Header>
            <div>
              <Modal.Body>
                <Form>
                  <Row>
                    <Modal.Title className="pl-4 mb-4">
                      Personal Details
                    </Modal.Title>
                  </Row>
                  <Row className="my-5">
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>First Name*</Form.Label>
                      <Form.Control
                        type="text"
                        name="first_name"
                        value={first_name}
                        placeholder="First Name"
                        onChange={this.handleChange}
                      />
                      {this.validator.message(
                        "first_name",
                        first_name,
                        "required|alpha_space|min:2|max:15",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The teacher first name is required.",
                          },
                        }
                      )}
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput2"
                    >
                      <Form.Label>Last Name*</Form.Label>
                      <Form.Control
                        type="text"
                        name="last_name"
                        value={last_name}
                        placeholder="Last Name"
                        onChange={this.handleChange}
                      />
                      {this.validator.message(
                        "last_name",
                        last_name,
                        "required|alpha_space|min:2|max:15",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The teacher last name is required.",
                          },
                        }
                      )}
                    </Form.Group>
                  </Row>
                  <Row className="my-5">
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput2"
                    >
                      <Form.Label>NIC*</Form.Label>
                      <Form.Control
                        type="text"
                        name="nic"
                        placeholder="NIC"
                        onChange={this.handleChange}
                        value={nic}
                      />
                      {this.validator.message("nic", nic, "required|min:8", {
                        className: "text-danger",
                        messages: {
                          required: "The teacher nic is required.",
                        },
                      })}
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput2"
                    >
                      <Form.Label>DOB*</Form.Label>
                      <div className="col-md-12 px-0">
                        <DatePicker
                          className="py-2 form-control w-100 col-md-12" // Add Bootstrap form control class
                          selected={
                            this.state.dob
                              ? new Date(this.state.dob)
                              : undefined
                          }
                          name="dob"
                          onChange={this.handleDatePickerChange}
                          dateFormat="dd/MM/yyyy" // Set custom date format
                          placeholderText="Date of Birth"
                          wrapperClassName="react-datePicker"
                        />
                      </div>
                      {this.validator.message(
                        "dob",
                        dob,
                        "required|dateBefore",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The date of birth is required.",
                          },
                        }
                      )}
                    </Form.Group>
                  </Row>
                  <Row className="my-5">
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput3"
                    >
                      <Form.Label>Email*</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={email}
                        placeholder="example@gmail.com"
                        onChange={this.handleChange}
                        disabled={true}
                      />
                      {this.validator.message(
                        "email",
                        email,
                        "required|email",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The email is required.",
                          },
                        }
                      )}
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput3"
                    >
                      <Form.Label>Gender*</Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        name="gender_id"
                        value={gender_id}
                        onChange={this.handleChange}
                        defaultValue={""}
                      >
                        <option hidden value="">
                          Select
                        </option>
                        {genders.map((gender) => (
                          <option
                            key={gender.gender_id}
                            value={gender.gender_id}
                          >
                            {gender.name}
                          </option>
                        ))}
                      </Form.Select>
                      {this.validator.message(
                        "gender_id",
                        gender_id,
                        "required",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The gender is required.",
                          },
                        }
                      )}
                    </Form.Group>
                  </Row>

                  <Row className="my-5">
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput3"
                    >
                      <Form.Label>Phone Number*</Form.Label>
                      <Form.Control
                        type="text"
                        name="phone_number"
                        value={phone_number}
                        placeholder="Phone Number"
                        onChange={this.handleChange}
                      />
                      {this.validator.message(
                        "phone_number",
                        phone_number,
                        "required|numeric|between:9,10|phone_number",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The phone number is required.",
                          },
                        }
                      )}
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput2"
                    >
                      <Form.Label>Permanent Address*</Form.Label>
                      <Form.Control
                        type="text"
                        name="address_1"
                        placeholder="Permanent Address"
                        onChange={this.handleChange}
                        value={address_1}
                      />
                      {this.validator.message(
                        "address_1",
                        address_1,
                        "required",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The permanent address is required.",
                          },
                        }
                      )}
                    </Form.Group>
                  </Row>

                  <Row className="my-5">
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Status*</Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        name="status_id"
                        value={status_id}
                        onChange={this.handleChange}
                        defaultValue={""}
                      >
                        <option hidden value="">
                          Select
                        </option>
                        {adm_statuses.map((status) => (
                          <option
                            key={status.status_id}
                            value={status.status_id}
                          >
                            {status.name}
                          </option>
                        ))}
                      </Form.Select>
                      {this.validator.message(
                        "status_id",
                        status_id,
                        "required",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The status is required.",
                          },
                        }
                      )}
                    </Form.Group>
                  </Row>

                  <Row className="my-5">
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput2"
                    >
                      {/* {this.validator.message(
                            "address_1",
                            address_1,
                            "address|required",
                            {
                            className: "text-danger",
                            messages: {
                                required: "The Address 1 is required.",
                                address: "The address 1 must be a valid address",
                            },
                            }
                        )} */}
                    </Form.Group>
                  </Row>
                  <Row className="my-5">
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput2"
                    >
                      <Form.Label>Employment Type</Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        name="type_id"
                        onChange={this.handleChange}
                        value={type_id}
                      >
                        <option value="">Select</option>
                        {empTypes.map((emp) => (
                          <option value={emp.type_id} key={emp.type_id}>
                            {emp.employment_type}
                          </option>
                        ))}
                      </Form.Select>
                      {/* {this.validator.message(
                            "country_id",
                            country_id,
                            "required",
                            {
                            className: "text-danger",
                            messages: {
                                required: "The Country is required.",
                            },
                            }
                        )} */}
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput3"
                    >
                      <Form.Label>Mode Of Employment</Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        name="mode_id"
                        onChange={this.handleChange}
                        value={mode_id}
                      >
                        <option value="">Select</option>
                        {modes?.map((mode) => (
                          <option value={mode.mode_id} key={mode.mode_id}>
                            {mode.mode_of_employment}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Row>
                  <Row className="my-5">
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput3"
                    >
                      <Form.Label>Higher Educational Qualifications</Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        name="edu_id"
                        onChange={this.handleChange}
                        value={edu_id}
                      >
                        <option value="">Select</option>
                        {education?.map((edu) => (
                          <option value={edu.id} key={edu.id}>
                            {edu.title}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>

                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput2"
                    >
                      <Form.Label>
                        Higher Professional Qualifications
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="higher_professional_qualifications"
                        placeholder="Higher Professional Qualifications"
                        onChange={this.handleChange}
                        value={higher_professional_qualifications}
                      />
                    </Form.Group>
                  </Row>
                  <Row className="my-5">
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput2"
                    ></Form.Group>
                  </Row>
                  <Row className="my-5">
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Industry Experience (Years)</Form.Label>
                      <Form.Control
                        type="number"
                        name="industry_experience"
                        placeholder="Industry Experience in years"
                        onChange={this.handleChange}
                        value={industry_experience}
                      />
                    </Form.Group>

                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput2"
                    >
                      <Form.Label>Teaching Experience (Years)</Form.Label>
                      <Form.Control
                        type="number"
                        name="teaching_experience"
                        placeholder="Teaching Experience in years"
                        onChange={this.handleChange}
                        value={teaching_experience}
                      />
                    </Form.Group>
                  </Row>

                  <Row className="pt-5">
                    <Modal.Title className="pl-4 mb-4">
                      Courses Assigned
                    </Modal.Title>
                  </Row>

                  <div className="cnt">
                    <Row className="course-list-container cNTableRow">
                      <Col>
                        {teacherLoading ? (
                          <div className="spinner-container">
                            <CircularProgress />
                          </div>
                        ) : (
                          <TableContainer
                            component={Paper}
                            className="course-table-container"
                          >
                            <Table aria-label="course table">
                              <TableHead className="table-head">
                                <TableRow>
                                  <TableCell className="table-cell">
                                    Select
                                  </TableCell>
                                  <TableCell className="table-cell">
                                    Course Name
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {enrollments.map((course) => (
                                  <TableRow
                                    key={course.mid}
                                    className="table-row"
                                  >
                                    <TableCell className="table-cell cNTblCells">
                                      <Checkbox
                                        checked={checked_enrollments.includes(
                                          course.mid
                                        )}
                                        onChange={() =>
                                          this.handleCheckboxChange(course.mid)
                                        }
                                        className="course-checkbox"
                                      />
                                    </TableCell>
                                    <TableCell className="table-cell cNTblCells">
                                      {course.breadcrumb}
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        )}
                      </Col>
                    </Row>
                  </div>
                  <Modal.Footer>
                    <Button
                      className="modal-btn"
                      id="modal-close-button"
                      style={closeBtnStyle}
                      onClick={() =>
                        this.handleSweetAlert(
                          this.toggleUpdateTeacherModal,
                          "showModal"
                        )
                      }
                    >
                      Close
                    </Button>
                    <Button
                      className="modal-btn"
                      variant="primary"
                      style={addBtnStyle}
                      onClick={this.handleEditSubmit}
                    >
                      Save changes
                    </Button>
                  </Modal.Footer>
                </Form>
              </Modal.Body>
            </div>
          </Modal>

          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.showPrivModel}
            onHide={this.togglePrivAddition}
          >
            <Modal.Header closeButton>
              <Modal.Title>Assign Role</Modal.Title>
            </Modal.Header>
            <div>
              <Modal.Body>
                {this.state.isPrivilegeModalLoading ? (
                  <div className="loading-container">
                    <Spinner animation="border" role="status">
                      <span className="sr-only">Loading...</span>
                    </Spinner>
                  </div>
                ) : (
                  <div>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell className="thead">Module</TableCell>
                          <TableCell className="thead">Role Code</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {assignedRoles?.map((role, index) => (
                          <TableRow key={index}>
                            <TableCell className="tData">
                              {role.module}
                            </TableCell>
                            <TableCell className="tData">
                              {role.role_code}
                            </TableCell>
                            <TableCell>
                              {role.role_code !== "ASSR" && (
                                <div className="btn-group">
                                  {editVisibility && (
                                    <Button
                                      onClick={() =>
                                        this.handleDeleteRoleCode(role)
                                      }
                                      className="btn btn-icon btn-danger btn-sm m-1 delete-assement-btn flaticon-delete"
                                      title="Delete"
                                    />
                                  )}
                                </div>
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </div>
                )}
                <Form>
                  <Row className="my-5">
                    <Form.Group
                      as={Col}
                      md="10"
                      controlId="exampleForm.ControlInput3"
                    >
                      <Form.Label>Role*</Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        name="role_code"
                        onChange={this.handleChange}
                        value={role_code}
                      >
                        <option value="">Select</option>
                        {roles?.map((role) => {
                          if (role.role_code === "ASAD") {
                            return (
                              <option
                                value={role.role_code}
                                key={role.role_code}
                              >
                                {role.role_code}
                              </option>
                            );
                          }
                        })}
                      </Form.Select>
                    </Form.Group>
                    <div className="d-flex align-items-end">
                      {editVisibility && !!role_code && (
                        <Button
                          style={addBtnStyle}
                          onClick={() => this.handleCreateRole()}
                        >
                          Add
                        </Button>
                      )}
                    </div>
                  </Row>

                  <Modal.Footer>
                    <Button
                      className="mb-4"
                      id="modal-close-button"
                      style={closeBtnStyle}
                      onClick={this.close}
                    >
                      Close
                    </Button>
                  </Modal.Footer>
                </Form>
              </Modal.Body>
            </div>
          </Modal>
        </div>
      </>
    );
  }
}
